// Product Subscription Selector Entrypoint
//
// Loads the legacy jQuery-dependent product subscription logic.
// jQuery is exposed globally by vendor.ts; this must run after vendorReady.
// jQuery UI datepicker is imported here as it's only needed on product pages.

// @TODO
// - Refactor the subscription selector logic to remove jQuery dependency and convert to a Web
//   Component.  removing the datepicker dependency if it's only used for the subscription selectora
const loadAssets = async () => {
  await import("jquery-ui/ui/widgets/datepicker");
  await import("@/vendor/product_subscription_js.js");
}

async function load() {
  if ((window as any).__vendorReady) {
    await loadAssets();
  } else {
    window.addEventListener("vendorReady", loadAssets, { once: true });
  }
}

load();
